export const NAVIGATION = [
  { category: 'energy',
    icon: 'lightbulb',
    items: { getStarted: '/compare-gas-electricity-prices/',
             dual: '/compare-gas-electricity-prices/dual-fuel/',
             electricity: '/compare-gas-electricity-prices/electricity/',
             gas: '/compare-gas-electricity-prices/gas/',
             green: '/compare-gas-electricity-prices/go-green/',
             business: '/compare-gas-electricity-prices/business/' } },
  { category: 'insurance',
    icon: 'kit-medical',
    items: { getStarted: '/compare-insurance/',
            mi: '/compare-car-insurance/',
            hi: '/compare-home-insurance/',
            mp: '/compare-mortgage-protection-insurance/',
            li: '/compare-life-insurance/',
            si: '/compare-serious-illness-cover/',
            health: '/compare-health-insurance/' } },
  { category: 'broadband',
    icon: 'router',
    items: { getStarted: '/compare-tv-broadband-phone/' } },
  { category: 'mortgages',
    icon: 'house',
    items: { getStarted: '/compare-mortgages/' } },
  { category: 'banking',
    icon: 'coins',
    items: { getStarted: '/money/',
             savings: '/compare-savings-accounts/',
             current: '/compare-current-accounts/',
             credit: '/compare-credit-cards/',
             prepay: '/compare-prepaid-credit-cards/',
             loans: '/compare-loans/' } },
  { category: 'newsroom',
    icon: 'newspaper',
    items: {
             getStarted: '/newsroom/',
             blog: '/blog/',
             guides: '/guides/',
             media: '/media/',
             videos: '/videos/',
             podcasts: '/podcasts/',
             ads: '/ads/',
             priceChanges: '/price-change-calendar/'} }
];
